import Button, { type ButtonProps } from '@mui/material/Button';
import { Box } from '@mui/system';
import type { ReactNode } from 'react';
import SVGSpinner from './SVGSpinner';

interface Props extends ButtonProps {
    onClick?: () => Promise<void> | void;
    loading?: boolean;
    children?: ReactNode;
}

export default function LoadingButton({ onClick, loading, children, ...props }: Props) {
    return (
        <Button onClick={onClick} {...props} disabled={loading || props?.disabled}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                {children}
                {loading && <SVGSpinner />}
            </Box>
        </Button>
    );
}
